<template>
  <f7-page class="main-merchandise-movements">
    <template #fixed>
      <TheNavbar
        :style="appTheme"
        nav-title="Movimientos de Mercancía"
        back-btn-enable
      >
        <template #btn-right>
          <img
            v-if="listaExistenciasMovMerc.length > 0"
            class="padding-left"
            src="@/static/icons/btn_done.svg"
            width="37"
            @click="EventCheckBtn"
          >
        </template>
      </TheNavbar>
    </template>

    <!-- Input Selector de la cabecera -->
    <UCMultiSearchEntitySelector
      ref="UCMultiSearchEntitySelector"
      class="content-multi-selector"
      :conf="confUCMultiSelector"
      @change="EventChangeElementSearch"
      @selection="EventSelect"
    />

    <div
      v-if="showComponents"
      class="content-logistic-existence-components"
    >
      <PCLogisticExistenceUL
        v-if="enumScanModeSelected === 0"
        class="logistic-existence-ul"
      />

      <PCLogisticExistenceItem
        v-if="enumScanModeSelected === 1"
        class="logistic-existence-item"
      />

      <PCLogisticExistenceBatch
        v-if="enumScanModeSelected === 2"
        class="logistic-existence-batch"
      />
    </div>

    <f7-actions
      class="merchadise-movements-actions-sheet"
      :opened="actionNewMerchandiseMovement"
      @actions:closed="actionNewMerchandiseMovement = false"
    >
      <f7-block>
        <div class="content-action-sheet-merchandise-movements--items text-align-center">
          <span class="content-action-sheet-merchandise-movements--items__title">
            Indique el destino de la mercancía
          </span>
        </div>
        <div class="content-filters-merchandise-movements">
          <div
            v-if="esUnidadLogistica"
            class="content-filters-merchandise-movements__logistic-unit"
          >
            <div class="content-filters-merchandise-movements__logistic-unit--search">
              <UCSearchEntityERP
                ref="UCLogisticUnitComponent"
                :title="$t('common.logisticsUnit')"
                :placeholder="$t('searchEntity.logisticUnit.placeholder.searchByLogisticUnit')"
                :search-text="$t('searchEntity.logisticUnit.searchText')"
                :search-cancellation-text="$t('searchEntity.logisticUnit.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.logisticUnit.searchNotFoundText')"
                :end-point-for-code-search="GetLogisticUnit"
                :end-point-for-list="GetLogisticUnit"
                :property-entity-shown-input="['NumeroSerie']"
                :property-entity-shown-list-title="['NumeroSerie']"
                :min-text-search="4"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                :qr-search-show="true"
                :qr-search-params="{
                  showInputButton: true,
                  fabButtonShow: false,
                  allowManualCodeEntry: true,
                  autoOpenCamera: false,
                  autofocusOnInput: true,
                }"
                :disabled="locationSelected && Object.keys(locationSelected).length !== 0"
                @selection="EventLogisticUnitSelected"
                @qr-open-search="EventQrOpen"
              />
            </div>
            <img
              class="btnAdd"
              src="@/static/icons/ic_add_new.svg"
              width="55"
              @click="actionNewPale = true; actionNewMerchandiseMovement = false"
            >
          </div>
          <div class="content-filters-merchandise-movements__location">
            <UCSearchEntityERP
              ref="UCLocations"
              :title="$t('common.location')"
              :placeholder="$t('searchEntity.location.placeholder.searchByLocation')"
              :search-text="$t('searchEntity.location.searchText')"
              :search-cancellation-text="$t('searchEntity.location.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.location.searchNotFoundText')"
              :end-point-for-code-search="GetLocationsByCode"
              :end-point-for-list="GetLocations"
              :property-entity-shown-input="['Codigo', 'Nombre']"
              :property-entity-shown-list-title="['Nombre']"
              :property-entity-shown-list-subtitle="['Codigo']"
              :min-text-search="0"
              :autofocus-on-deselection="true"
              :auto-focus-on-empty-search-result="true"
              :qr-search-show="true"
              :qr-search-params="{
                showInputButton: true,
                fabButtonShow: false,
                allowManualCodeEntry: true,
                autoOpenCamera: false,
                autofocusOnInput: true,
              }"
              :disabled="logisticUnitselected && Object.keys(logisticUnitselected).length !== 0"
              @qr-open-search="EventQrOpen"
              @selection="EventLocationSelected"
            />
          </div>
        </div>
        <div class="content-action-sheet-merchandise-movements--items__buttons">
          <a
            class=""
            @click="actionNewMerchandiseMovement = false"
          >
            {{ $t('common.cancel').toUpperCase() }}
          </a>
          <a
            class="color-green aceptar-button"
            @click="MoveMerchandise(); actionNewMerchandiseMovement = false"
          >
            {{ $t('common.accept').toUpperCase() }}
          </a>
        </div>
      </f7-block>
    </f7-actions>

    <f7-actions
      class="merchadise-movements-actions-sheet"
      :opened="actionNewPale"
      @actions:closed="actionNewPale = false"
    >
      <f7-block>
        <div class="content-action-sheet-merchandise-movements--items text-align-center">
          <span class="content-action-sheet-merchandise-movements--items__title">
            Rellene los campos para generar un nuevo palé
          </span>
        </div>
        <div class="content-filters-merchandise-movements">
          <div
            class="content-filters-merchandise-movements__logistic-unit"
          >
            <div class="content-filters-merchandise-movements__logistic-unit--search">
              <UCSearchEntityERP
                :title="$t('common.logisticsUnit')"
                :placeholder="$t('searchEntity.logisticUnit.placeholder.logisticUnitType')"
                :search-text="$t('searchEntity.logisticUnit.searchText')"
                :search-cancellation-text="$t('searchEntity.logisticUnit.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.logisticUnit.searchNotFoundText')"
                :end-point-for-code-search="GetPalet"
                :end-point-for-list="GetPalet"
                :property-entity-shown-input="['Nombre', 'Codigo']"
                :property-entity-shown-list-title="['Nombre']"
                :property-entity-shown-list-subtitle="['Codigo']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                :qr-search-show="true"
                :qr-search-params="{
                  showInputButton: true,
                  fabButtonShow: false,
                  allowManualCodeEntry: true,
                  autoOpenCamera: false,
                  autofocusOnInput: true,
                }"
                @selection="EventPaletSelected"
              />
            </div>
          </div>
          <div class="content-filters-merchandise-movements__location">
            <UCSearchEntityERP
              :title="$t('common.location')"
              :placeholder="$t('searchEntity.location.placeholder.searchByLocation')"
              :search-text="$t('searchEntity.location.searchText')"
              :search-cancellation-text="$t('searchEntity.location.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.location.searchNotFoundText')"
              :end-point-for-code-search="GetLocationsByCode"
              :end-point-for-list="GetLocations"
              :property-entity-shown-input="['Nombre', 'Codigo']"
              :property-entity-shown-list-title="['Nombre']"
              :property-entity-shown-list-subtitle="['Codigo']"
              :min-text-search="0"
              :autofocus-on-deselection="true"
              :auto-focus-on-empty-search-result="true"
              :qr-search-show="true"
              :qr-search-params="{
                showInputButton: true,
                fabButtonShow: false,
                allowManualCodeEntry: true,
                autoOpenCamera: false,
                autofocusOnInput: true,
              }"
              @qr-open-search="EventQrLocationOpen"
              @selection="EventLocationNewPaleSelected"
            />
          </div>
        </div>
        <div class="content-action-sheet-merchandise-movements--items__buttons">
          <a
            class=""
            @click="actionNewPale = false"
          >
            {{ $t('common.cancel').toUpperCase() }}
          </a>
          <a
            class="color-green aceptar-button"
            @click="NewPaleCreated()"
          >
            {{ $t('common.accept').toUpperCase() }}
          </a>
        </div>
      </f7-block>
    </f7-actions>
  </f7-page>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState, mapWritableState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import { callExecuteSPERP } from '@/js/services/APIErp';
import { useWarehouseStore } from '@/js/stores/warehouse';

import icSearch from '@/static/icons/ic_search.svg';
import icCode from '@/static/icons/ic_code.svg';

import ConexionTA from '@/js/services/traceability/APITraceability';
import {
  ConfirmDialogGH,
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import TheNavbar from '@/components/TheNavbar.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import UCMultiSearchEntitySelector from '@/components/common/UCMultiSearchEntitySelector.vue';
import PCLogisticExistenceUL from '@/components/warehouse/manageItemLocation/PCLogisticExistenceUL.vue';
import PCLogisticExistenceItem from '@/components/warehouse/manageItemLocation/PCLogisticExistenceItem.vue';
import PCLogisticExistenceBatch from '@/components/warehouse/manageItemLocation/PCLogisticExistenceBatch.vue';

/** @import { SPApp } from '@erpagroapp/types' */

export default defineComponent({
  name: 'FrmManageItemLocationHome',

  components: {
    TheNavbar,
    UCMultiSearchEntitySelector,
    PCLogisticExistenceUL,
    PCLogisticExistenceItem,
    PCLogisticExistenceBatch,
    UCSearchEntityERP,
  },
  data() {
    return {
      enumScanModes: {
        UL: 0,
        ARTICLE: 1,
        PARTIDA: 2,
      },
      enumScanModeSelected: 0,
      actionNewMerchandiseMovement: false,
      qrOpen: false,
      showComponents: false, // muestra los compomentes
      locationSelected: {},
      logisticUnitselected: {},
      paletSelected: {},
      newPaleLocationSelected: {},
      actionNewPale: false,
      esUnidadLogistica: false,
    };
  },
  computed: {
    ...mapState(useAppConfigStore, ['userEnviroment']),

    ...mapState(useWarehouseStore, [
      'listaExistenciasSeleccionadasMovMerc',
      'listaExistenciasMovMerc',
    ]),

    ...mapWritableState(useWarehouseStore, ['listaExistenciasMovMerc', 'listaExistenciasSeleccionadasMovMerc']),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },

    confUCMultiSelector() {
      return [
        {
          id: 'UL',
          qrSearchShow: true,
          qrSearchParams: {
            showInputButton: true,
            fabButtonShow: false,
            barcodeSearchPrefix: 'barcode:',
            allowManualCodeEntry: true,
            autoOpenCamera: false,
            autofocusOnInput: true,
          },
          iconButton: icSearch,
          altButton: 'Icono lectura de cajas',
          placeholder: this.$t('common.logisticsUnit'),
          searchText: this.$t('searchEntity.logisticUnit.searchText'),
          searchCancellationText: this.$t('searchEntity.logisticUnit.searchCancellationText'),
          searchNotFoundText: this.$t('searchEntity.logisticUnit.searchNotFoundText'),
          minTextSearch: 3,
          procedureForSearch: /** @satisfies {SPApp} */ ({
            NombreSP: 'APPTRAZABILIDAD_ArticulosNumerosSerie',
            Parametros: [
              { NombreParametro: 'filtro', Valor: 'numeroserie:' },
              { NombreParametro: 'idGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
            ],
            EntidadMapear: 'Almacen.UnidadContenedoraJSON',
          }),
          propertyEntityShownInput: ['NumeroSerie'],
          propertyEntityShownListTitle: ['NumeroSerie'],
        },
        {
          id: 'ARTICLE',
          qrSearchShow: true,
          qrSearchParams: {
            showInputButton: true,
            fabButtonShow: false,
            barcodeSearchPrefix: '',
            allowManualCodeEntry: true,
            autoOpenCamera: false,
            autofocusOnInput: true,
          },
          iconButton: icCode,
          altButton: 'Icono lectura de artículos',
          placeholder: this.$t('common.article'),
          searchText: this.$t('searchEntity.article.searchText'),
          searchCancellationText: this.$t('searchEntity.article.searchCancellationText'),
          searchNotFoundText: this.$t('searchEntity.article.searchNotFoundText'),
          minTextSearch: 3,
          procedureForSearch: /** @satisfies {SPApp} */ ({
            NombreSP: 'APPERPAGRO_ArticulosXTipoArticulo',
            Parametros: [
              { NombreParametro: 'filtro', Valor: 'q:' },
              { NombreParametro: 'tipoArticulo', Valor: '-1' },
              { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo?.Empresa?.Id ?? 0 },
              { NombreParametro: 'fecha', Valor: new Date() },
              { NombreParametro: 'materiPrimaCheck', Valor: 0 },
            ],
            EntidadMapear: 'Comun.ArticuloJSON',
          }),
          propertyEntityShownInput: ['Nombre', 'Codigo'],
          propertyEntityShownListTitle: ['Nombre'],
          propertyEntityShownListSubitle: ['Codigo'],
        },
        {
          id: 'PARTIDA',
          qrSearchShow: true,
          qrSearchParams: {
            showInputButton: true,
            fabButtonShow: false,
            barcodeSearchPrefix: '',
            allowManualCodeEntry: true,
            autoOpenCamera: false,
            autofocusOnInput: true,
          },
          iconButton: icCode,
          altButton: 'Icono lectura de cajas',
          placeholder: this.$t('searchEntity.batch.placeholder.serialOrNumber'),
          searchText: this.$t('searchEntity.batch.searchText'),
          searchCancellationText: this.$t('searchEntity.batch.searchCancellationText'),
          searchNotFoundText: this.$t('searchEntity.batch.searchNotFoundText'),
          minTextSearch: 2,
          procedureForSearch: /** @satisfies {SPApp} */ ({
            NombreSP: 'APPERPAGRO_PartidasXFiltro',
            Parametros: [{ NombreParametro: 'filtro', Valor: 'q:' }],
            EntidadMapear: 'PartidaJSON',
          }),
          propertyEntityShownInput: ['Serie', 'Numero'],
          propertyEntityShownListTitle: ['Serie', 'Numero'],
        },

      ];
    },
  },

  beforeUnmount() {
    this.LimpiarListaExistencias();
  },

  methods: {
    /** Función de inicialización del componente de página. */
    StartComponent() {
      Log(this, this.StartComponent.name);
    },

    LimpiarListaExistencias() {
      Log(this, this.LimpiarListaExistencias.name);
      this.listaExistenciasMovMerc = [];
      this.listaExistenciasSeleccionadasMovMerc = [];
    },

    EventCheckBtn() {
      Log(this, this.EventCheckBtn.name);
      this.actionNewMerchandiseMovement = true;
      this.listaExistenciasSeleccionadasMovMerc = [];
      // this.listaExistenciasSeleccionadasMovMerc = this.listaExistenciasSeleccionadasMovMerc.filter((f) => f.checked);

      if (this.listaExistenciasMovMerc.length > 0) {
        if (this.listaExistenciasSeleccionadasMovMerc.length === 0) {
          this.listaExistenciasSeleccionadasMovMerc = this.listaExistenciasMovMerc.filter((f) => f.checked);
        } else {
          this.listaExistenciasMovMerc.forEach((l) => {
            const res = this.listaExistenciasSeleccionadasMovMerc.find((f) => f.Id === l.Id);

            if (!res) {
              this.listaExistenciasSeleccionadasMovMerc.push(l);
            }
          });
        }
      }

      this.listaExistenciasSeleccionadasMovMerc?.forEach((existencia) => {
        existencia.CantidadFinal = existencia.Seleccion;
      });
    },
    async EventChangeElementSearch() {
      Log(this, this.EventChangeElementSearch.name);
      if (this.listaExistenciasMovMerc.length > 0) {
        const resultConfirm = await ConfirmDialogGH('Se eliminarán los datos actuales.  ¿Quiere continuar?', 'Eliminar datos actuales');
        if (resultConfirm) {
          this.LimpiarListaExistencias();
          this.locationSelected = {};
          this.logisticUnitselected = {};
          this.paletSelected = {};
          this.newPaleLocationSelected = {};
          this.showComponents = false;
          this.enumScanModeSelected = (this.enumScanModeSelected + 1) % Object.keys(this.enumScanModes).length;
        }
      } else {
        this.LimpiarListaExistencias();
        this.showComponents = false;
        this.enumScanModeSelected = (this.enumScanModeSelected + 1) % Object.keys(this.enumScanModes).length;
      }
    },
    /**
     * @param {object} value
     */
    async EventSelect(value) {
      Log(this, this.EventSelect.name);

      if (value !== null) {
        this.$refs.UCMultiSearchEntitySelector.clear();
        this.showComponents = true;
        if (this.enumScanModeSelected === 0) {
          const result = await this.GetReservation(value, true);
          if (result) {
            this.GetANSExistences(value);
          }
        }
        if (this.enumScanModeSelected === 1) {
          this.GetItemsExistences(value);
        }
        if (this.enumScanModeSelected === 2) {
          this.GetBatchExistences(value);
        }
      }
    },

    /**
     * @param {object} obj
     */
    async EventLogisticUnitSelected(obj) {
      Log(this, this.EventLogisticUnitSelected.name);
      if (obj) {
        const res = await this.GetReservation(obj, false);

        if (res) {
          this.logisticUnitselected = obj;
          this.esUnidadLogistica = this.logisticUnitselected.TipoUnidadContenedora === 0;
          if (this.logisticUnitselected && this.logisticUnitselected.Ubicacion !== null) {
            this.$refs.UCLocations.SelectEntity(this.logisticUnitselected.Ubicacion, true);
          }
        }
        this.actionNewMerchandiseMovement = true;
      }
    },
    /**
     * @param {object} obj
     */
    EventPaletSelected(obj) {
      Log(this, this.EventPaletSelected.name);
      if (obj) {
        this.actionNewPale = true;
      }
      this.paletSelected = obj;
    },
    /**
     * @param {object} obj
     */
    EventLocationSelected(obj) {
      Log(this, this.EventLocationSelected.name);
      if (obj) {
        this.actionNewMerchandiseMovement = true;
      }
      this.locationSelected = obj;
    },
    /**
     * @param {boolean} val
     */
    EventQrOpen(val) {
      Log(this, this.EventQrOpen.name);
      this.actionNewMerchandiseMovement = !val;
      this.qrOpen = val;
    },
    EventLocationNewPaleSelected(obj) {
      Log(this, this.EventLocationNewPaleSelected.name);
      if (obj) {
        this.actionNewPale = true;
      }
      this.newPaleLocationSelected = obj;
    },

    EventQrLocationOpen(val) {
      Log(this, this.EventQrLocationOpen.name);
      this.actionNewPale = !val;
      this.qrOpen = val;
    },

    async PocesarDatos(result) {
      Log(this, this.PocesarDatos.name);
      for (const d of result) {
        this.listaExistenciasMovMerc.push(d);
      }

      // if (this.enumScanModeSelected === 0) {
      //   this.$refs.PCLogisticExistenceUL.FilterData();
      // }
      // if (this.enumScanModeSelected === 1) {
      //   this.$refs.PCLogisticExistenceItem.FilterData();
      // }
      // if (this.enumScanModeSelected === 2) {
      //   this.$refs.PCLogisticExistenceBatch.FilterData();
      // }
    },

    // ****************************************************************** \\
    // ************************** CONEXIONES **************************** \\
    // ****************************************************************** \\

    async MoveMerchandise() {
      Log(this, this.MoveMerchandise.name);
      PreloaderGH(true, false, 'Cambiando movimiento', '');

      const listaExistenciasSeleccionadas = [...this.listaExistenciasSeleccionadasMovMerc];
      for (const item of listaExistenciasSeleccionadas) {
        if (item.Cantidad !== item.CantidadFinal) {
          item.Cantidad = item.CantidadFinal;
        }
      }

      const idUbicacion = this.locationSelected ? this.locationSelected.Id : 0;
      const idLogisticUnitSelected = this.logisticUnitselected && Object.keys(this.logisticUnitselected).length !== 0 ? this.logisticUnitselected.Id : 0;

      try {
        const result = await ConexionTA.callMovimientoMercanciaCambioUbicacion(listaExistenciasSeleccionadas, idUbicacion, idLogisticUnitSelected);

        if (result.Valor) {
          this.$refs.UCLocations.Clear();
          if (this.esUnidadLogistica) {
            this.$refs.UCLogisticUnitComponent.Clear();
          }
          this.LimpiarListaExistencias();
          HiNotification.Toast('Movimiento realizado con éxito');
        } else {
          HiNotification.Toast('No se pudo realizar el movimiento');
        }
      } catch (error) {
        HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
        LogError(error);
      }

      PreloaderGH(false);
    },

    async CreateNewPale() {
      Log(this, this.CreateNewPale.name);
      PreloaderGH(true, false, 'Creando movimiento a nuevo pale...', '');

      if (Object.keys(this.paletSelected).length === 0) {
        PreloaderGH(true, false, 'Creando pale...', '');
        HiNotification.Toast('Necesitas seleccionar un tipo de palé');
        return;
      }
      if (Object.keys(this.newPaleLocationSelected).length === 0) {
        PreloaderGH(true, false, 'Creando pale...', '');
        HiNotification.Toast('Necesitas seleccionar una ubicación para el nuevo palé');
        return;
      }

      const listaExistenciasSeleccionadas = [...this.listaExistenciasSeleccionadasMovMerc];
      for (const item of listaExistenciasSeleccionadas) {
        if (item.Cantidad !== item.CantidadFinal) {
          item.Cantidad = item.CantidadFinal;
        }
      }

      await ConexionTA.callMovimientoMercanciaConNuevoPale(this.paletSelected.Id, this.newPaleLocationSelected.Id, listaExistenciasSeleccionadas).then((result) => {
        if (result.Valor) {
          PreloaderGH(false);
          HiNotification.Toast('Mercancía ubicada en el nuevo palé creado');
          this.actionNewPale = false;
          this.$refs.UCLocations.Clear();
          if (this.esUnidadLogistica) {
            this.$refs.UCLogisticUnitComponent.Clear();
          }
          this.LimpiarListaExistencias();
        } else {
          PreloaderGH(false);
          HiNotification.Toast(`${result.Mensaje}`);
        }
      })
        .catch((error) => {
          PreloaderGH(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(error);
        });
    },

    /**
     * @param {string} params
     */
    GetLocationsByCode(params) {
      this.actionNewPale = false;
      this.actionNewMerchandiseMovement = false;
      Log(this, this.GetLocationsByCode.name);
      if (this.qrOpen) {
        this.qrOpen = false;
        return callExecuteSPERP(
          'APPERPAGRO_UbicacionesXIdGrupoEmpresarialXAlmacen',
          [
            { NombreParametro: 'filtro', Valor: `barcode:${params}` },
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
            { NombreParametro: 'idsAlmacen', Valor: '' },
          ],
          'Almacen.UbicacionJSON',
        );
      }
      return callExecuteSPERP(
        'APPERPAGRO_UbicacionesXIdGrupoEmpresarialXAlmacen',
        [
          { NombreParametro: 'filtro', Valor: `q:${params}` },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsAlmacen', Valor: '' },
        ],
        'Almacen.UbicacionJSON',
      );
    },
    GetLocations() {
      Log(this, this.GetLocations.name);
      this.actionNewPale = false;
      this.actionNewMerchandiseMovement = false;
      return callExecuteSPERP(
        'APPERPAGRO_UbicacionesXIdGrupoEmpresarialXAlmacen',
        [
          { NombreParametro: 'filtro', Valor: '' },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsAlmacen', Valor: '' },
        ],
        'Almacen.UbicacionJSON',
      );
    },
    /**
     * @param {string} code
     */
    /* unidad logistica */
    GetLogisticUnit(code) {
      Log(this, this.GetLogisticUnit.name);
      this.actionNewMerchandiseMovement = false;
      if (this.qrOpen) {
        this.qrOpen = false;
        return callExecuteSPERP(
          'APPTRAZABILIDAD_ArticulosNumerosSerie',
          [
            { NombreParametro: 'filtro', Valor: `barcode:${code}` }, // Id, barcode, numeroserie
            { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          ],
          'Almacen.UnidadContenedoraJSON',
        );
      }
      return callExecuteSPERP(
        'APPTRAZABILIDAD_ArticulosNumerosSerie',
        [
          { NombreParametro: 'filtro', Valor: `numeroserie:${code}` }, // Id, barcode, numeroserie
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
        ],
        'Almacen.UnidadContenedoraJSON',
      );
    },

    /* unidad logistica */
    GetPalet() {
      Log(this, this.GetPalet.name);
      this.actionNewPale = false;
      return callExecuteSPERP(
        'APPERPAGRO_ArticulosXTipoArticulo',
        [
          { NombreParametro: 'filtro', Valor: 'q:' },
          { NombreParametro: 'tipoArticulo', Valor: 0 },
          { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo?.Empresa?.Id ?? 0 },
          { NombreParametro: 'fecha', Valor: new Date() },
          { NombreParametro: 'materiPrimaCheck', Valor: 0 },
        ],
        'Comun.ArticuloJSON',
      );
    },

    /**
     * @param {object} value
     * @param {boolean} allowRemoveReservation
     */
    async GetReservation(value, allowRemoveReservation) {
      Log(this, this.GetANSExistences.name);
      PreloaderGH(true, false, 'Buscando reservas...', '');
      try {
        let result = null;
        result = await callExecuteSPERP(
          'APPTRAZABILIDAD_ReservasXIdUnidadLogistica',
          [
            { NombreParametro: 'IdUL', Valor: value.Id },
          ],
          'Almacen.UnidadContenedoraReservaJSON',
        );

        PreloaderGH(false);
        if (result.data.length > 0 && result.statusText === 'OK') {
          if (allowRemoveReservation) {
            const resultConfirm = await ConfirmDialogGH(`El Numero de serie ${value.NumeroSerie} está reservado. Si continúa se eliminará la reserva.  ¿Quiere continuar?`, 'Numero de seria con reserva');
            if (resultConfirm) {
              return true;
            }
            return false;
          }
          HiNotification.Alert(`El Número de serie ${value.NumeroSerie} tiene reserva y no puede modificarse su contenido`, 'Reservado');
          return false;
        }
        return true;
      } catch (error) {
        PreloaderGH(false);
        LogError(this, this.GetANSExistences.name, error);
        return null;
      }
    },

    /**
     * @param {object} value
     */
    async GetANSExistences(value) {
      Log(this, this.GetANSExistences.name);
      PreloaderGH(true, false);
      try {
        let result = null;
        result = await callExecuteSPERP(
          'APPTRAZABILIDAD_AcumuladoExistenciasXAnsDetalle',
          [
            { NombreParametro: 'IdANS', Valor: value.Id },
          ],
          'Almacen.AcumuladoExistenciasJSON',
        );
        // let newList = [];
        //   if (this.listaExistenciasMovMerc.length > 0) {
        //     const rep = this.listaExistenciasMovMerc.filter((f) => f.Partida.Id === value.Id);
        //     if (rep.length > 0) {
        //       HiNotification.Alert(`La partida ${value.Serie}/${value.Numero} se encuentra en la lista`);
        //       PreloaderGH(false);
        //       return null;
        //     }

        //     newList = [...this.listaExistenciasMovMerc];
        //     for (const d of result.data) {
        //       newList.push(d);
        //     }
        //   } else {
        //     newList = lista;
        //   }

        if (result.data.length > 0) {
          let newList = [];
          if (this.listaExistenciasMovMerc.length > 0) {
            const rep = this.listaExistenciasMovMerc.filter((f) => f.UnidadContenedora.Id === value.Id);
            if (rep.length > 0) {
              HiNotification.Alert(`El Número de serie ${value.NumeroSerie} se ecuentra en la lista`);
              PreloaderGH(false);
              return null;
            }

            newList = [...this.listaExistenciasMovMerc];
            for (const d of result.data) {
              newList.push(d);
            }
          } else {
            newList = result.data;
          }

          PreloaderGH(false);
          this.listaExistenciasMovMerc = newList.map((e) => ({ ...e, checked: false }));
        } else {
          PreloaderGH(false);
          HiNotification.Alert(`El Número de serie ${value.NumeroSerie} no está en existencias`, this.$t('common.error'));
        }

        return null;
      } catch (error) {
        PreloaderGH(false);
        LogError(this, this.GetANSExistences.name, error);
        return null;
      }
    },

    /**
     * @param {object} value
     */
    async GetItemsExistences(value) {
      Log(this, this.GetItemsExistences.name);
      PreloaderGH(true, false);
      try {
        let result = null;
        result = await callExecuteSPERP(
          'APPTRAZABILIDAD_AcumuladoExistenciasXArticuloDetalle',
          [
            { NombreParametro: 'IdArticulo', Valor: value.Id },
          ],
          'Almacen.AcumuladoExistenciasJSON',
        );

        if ((result.statusText === 'OK' || result.status === 200) && result.data.length > 0) {
          // COGEMOS SOLO LOS QUE NO TENGAN UL
          const lista = result.data.filter((d) => d.UnidadContenedora === null);
          const listaConUL = result.data.filter((d) => d.UnidadContenedora !== null);

          if (listaConUL !== null && listaConUL.length > 0) {
            HiNotification.Toast('El Artículo tiene mercancía en Unidad Logística');
          }

          let newList = [];
          if (this.listaExistenciasMovMerc.length > 0) {
            const rep = this.listaExistenciasMovMerc.filter((f) => f.Articulo.Id === value.Id);
            if (rep.length > 0) {
              HiNotification.Alert(`El articulo ${value.Nombre} se ecuentra en la lista`);
              PreloaderGH(false);
              return null;
            }
            newList = [...this.listaExistenciasMovMerc];
            for (const d of result.data) {
              newList.push(d);
            }
          } else {
            newList = lista;
          }

          PreloaderGH(false);
          this.listaExistenciasMovMerc = newList.map((e) => ({ ...e, checked: false }));
        } else {
          PreloaderGH(false);
          HiNotification.Alert(`El Articulo ${value.Nombre} no está en existencias`, this.$t('common.error'));
        }

        return null;
      } catch (error) {
        LogError(this, this.GetItemsExistences.name, error);
        return null;
      }
    },
    /**
     * @param {object} value
     */
    async GetBatchExistences(value) {
      Log(this, this.GetBatchExistences.name);
      PreloaderGH(true, false);
      try {
        let result = null;
        result = await callExecuteSPERP(
          'APPTRAZABILIDAD_AcumuladoExistenciasXPartidaDetalle',
          [
            { NombreParametro: 'IdPartida', Valor: value.Id },
          ],
          'Almacen.AcumuladoExistenciasJSON',
        );

        if (result.data.length > 0 && result.statusText === 'OK') {
          // COGEMOS SOLO LOS QUE NO TENGAN UL
          const lista = result.data.filter((d) => d.UnidadContenedora === null);
          const listaConUL = result.data.filter((d) => d.UnidadContenedora !== null);

          if (listaConUL !== null && listaConUL.length > 0) {
            HiNotification.Toast('La partida tiene mercancía en Unidad Logística');
          }

          let newList = [];
          if (this.listaExistenciasMovMerc.length > 0) {
            const rep = this.listaExistenciasMovMerc.filter((f) => f.Partida.Id === value.Id);
            if (rep.length > 0) {
              HiNotification.Alert(`La partida ${value.Serie}/${value.Numero} se encuentra en la lista`);
              PreloaderGH(false);
              return null;
            }

            newList = [...this.listaExistenciasMovMerc];
            for (const d of result.data) {
              newList.push(d);
            }
          } else {
            newList = lista;
          }

          PreloaderGH(false);
          this.listaExistenciasMovMerc = newList.map((e) => ({ ...e, checked: false }));
        } else {
          PreloaderGH(false);
          HiNotification.Alert(`La partida ${value.Serie} / ${value.Numero} no está en existencias`, this.$t('common.error'));
        }

        return null;
      } catch (error) {
        LogError(this, this.GetBatchExistences.name, error);
        return null;
      }
    },

  },
});
</script>

<style lang="scss">
.main-merchandise-movement {
  background: #fff;

  .disabled-component {
    opacity: 0.6;
    pointer-events: none;
  }
}

.logistic-existence-ul {
  height: calc(100vh - var(--f7-page-navbar-offset) - 75px);
  overflow-y: scroll;
}

.logistic-existence-item {
  height: calc(100vh - var(--f7-page-navbar-offset) - 75px);
  overflow-y: scroll;
}

.logistic-existence-batch {
  height: calc(100vh - var(--f7-page-navbar-offset) - 75px);
  overflow-y: scroll;
}

.merchadise-movements-actions-sheet {
  background: #fff;
  height: 350px;

  .content-filters-merchandise-movements {
    padding: 5px;
    height: calc(350px - 65px - 45px);

    &__logistic-unit {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;

      .btnAdd {
        padding-left: 5px;
      }

      &--search {
        width: -webkit-fill-available;
      }
    }
  }

  .content-action-sheet-merchandise-movements--items {
    padding-bottom: 20px;

    &__title {
      font-size: 17px;
      padding-bottom: 21px;
    }

    &__buttons {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;

      a {
        font-size: 14px;
        font-weight: 400;
      }

      .aceptar-button {
        font-size: 18px;
        font-weight: 500;
      }
    }
  }
}
</style>
